import {Basic} from "./Basic";
import {Browser} from "./Browser";
import {Display} from "./Display";

// display js only elements
document.body.classList.remove('w__js--off');

window.addEventListener('DOMContentLoaded',function()
{
    // set variables
    Basic.init();

    // get environment
    Browser.analyze();
    Display.analyze();

    // get language from HTML
    Basic.lang = document.documentElement.lang;

    // remove hover class on mobile devices
    if(Browser.mobile === true)
    {
        document.body.classList.remove('w__hover');
        document.body.classList.add('w__mobile');
    }

    // fix select padding on firefox < 107
    if(Browser.engine === 'gecko' && Browser.version < 107)
    {
        document.body.classList.add('w__fix--ff-select');
    }

    // add event listeners
    Basic.add_changeEvent();
    Basic.add_clickEvent();
    Basic.add_submitEvent();

    // start interactivity
    Basic.do_afterLoad();
});

// window resize detection
window.addEventListener('resize',() =>
{
    cancelAnimationFrame(Basic.resizeTimer);
    Basic.resizeTimer = requestAnimationFrame(Basic.process_resize);
});